import { on } from 'js/lib/events'
import { createAnalyticsGroup } from 'js/lib/analytics'

const track = createAnalyticsGroup('bonded-promo-banner')

on('click', '.js-bonded-promo-banner-link', function (event) {
  const label = event.target.dataset.kind
  track('clicked', label)
})
